import { Typography } from "@mui/material";
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles((theme) => ({
  careerBody1Style: {
    fontSize: 18,
    letterSpacing: 0.15,
    fontFamily: "Open sans",
    lineHeight: "150%",
    fontWeight: 400,
    color: "black",
    marginBottom: ".5rem",
    margin: "5px 0px",
  },
  h2Title: {
    fontSize: 34,
    letterSpacing: 0.15,
    fontFamily: "Poppins",
    fontWeight: 600,
    bottom: 5,
    paddingBottom: 5,
    borderBottom: "5px solid #2eb790 !important",
    display: "inline-block",
    maxWidth: "60%",
  },
}));

const CareerBody = ({ body1, title }) => {
  const classes = useStyles();
  return (
    <>
      <Typography className={classes.h2Title} align="left" role="heading" aria-level="2">
        {title}
      </Typography>
      <br />
      <br />
      <Typography
        variant="body1"
        align="left"
        className={classes.careerBody1Style}
        role="article"
        aria-label={`Career information about ${title}`}>
        {body1}
      </Typography>
    </>
  );
};
export default CareerBody;
